module.exports = __webpack_public_path__ + "static/media/amanDevLogo.b0aeaa23.jpg";